import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}

.dashboard-shell {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: #eef3f7;
}

.dashboard-header {
  gap: 12px;
  padding: 10px 14px;
  border-bottom-color: #cfd8e3;
  background: linear-gradient(180deg, #fbfcfd 0%, #eef4f8 100%);
}

.dashboard-header-main {
  min-width: 0;
  flex: 1;
}

.dashboard-header-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.dashboard-header-title-row {
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.dashboard-header-title {
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
}

.dashboard-header-time {
  font-size: 11px;
  color: #64748b;
}

.dashboard-header-sub {
  margin-top: 2px;
  font-size: 11px;
  color: #64748b;
}

.dashboard-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.dashboard-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px 14px 16px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 12px;
  min-height: 100%;
}

.dashboard-main-panel,
.dashboard-side-panel {
  min-width: 0;
}

.dashboard-side-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dashboard-focus-panel,
.dashboard-metric-card,
.dashboard-lane,
.dashboard-side-card {
  border: 1px solid #d8e1eb;
  background: #ffffff;
}

.dashboard-focus-band {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  gap: 12px;
  margin-bottom: 12px;
}

.dashboard-focus-panel {
  padding: 14px;
  background: linear-gradient(135deg, #ffffff 0%, #f6fafc 100%);
}

.dashboard-focus-kicker,
.dashboard-lane-kicker,
.dashboard-side-kicker {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.dashboard-focus-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dashboard-focus-wait {
  font-size: 11px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.dashboard-focus-name {
  margin-top: 10px;
  font-size: 22px;
  line-height: 1.1;
  font-weight: 800;
  color: #0f172a;
}

.dashboard-focus-meta {
  margin-top: 6px;
  font-size: 11px;
  color: #64748b;
}

.dashboard-focus-note {
  margin-top: 10px;
  min-height: 52px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #334155;
}

.dashboard-focus-actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.dashboard-focus-empty-title {
  margin-top: 10px;
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.dashboard-focus-empty-sub {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.5;
  color: #64748b;
}

.dashboard-metric-stack {
  display: grid;
  gap: 10px;
}

.dashboard-metric-card {
  padding: 12px;
  border-left: 4px solid #cbd5e1;
}

.dashboard-metric-card--emerald {
  border-left-color: #10b981;
}

.dashboard-metric-card--blue {
  border-left-color: #3b82f6;
}

.dashboard-metric-card--violet {
  border-left-color: #8b5cf6;
}

.dashboard-metric-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
}

.dashboard-metric-value {
  display: block;
  margin-top: 6px;
  font-size: 24px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.dashboard-metric-sub {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
}

.dashboard-lane-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-lane {
  padding: 12px;
  border-top: 3px solid #cbd5e1;
}

.dashboard-lane--emerald {
  border-top-color: #10b981;
}

.dashboard-lane--blue {
  border-top-color: #3b82f6;
}

.dashboard-lane--violet {
  border-top-color: #8b5cf6;
}

.dashboard-lane-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-lane-title {
  margin-top: 2px;
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.dashboard-lane-count {
  font-size: 20px;
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.dashboard-lane-sub {
  margin-top: 6px;
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.dashboard-lane-item {
  width: 100%;
  margin-top: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 10px;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s;
  cursor: pointer;
}
.dashboard-lane-item:hover {
  border-color: #94a3b8;
  background: #ffffff;
}

.dashboard-lane-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dashboard-lane-name {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}

.dashboard-lane-wait,
.dashboard-handoff-meta,
.dashboard-mini-meta,
.dashboard-side-sub,
.dashboard-lane-meta,
.dashboard-lane-note,
.dashboard-snapshot-label {
  font-size: 11px;
}

.dashboard-lane-wait {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.dashboard-lane-meta {
  margin-top: 4px;
  color: #64748b;
}

.dashboard-lane-note {
  margin-top: 6px;
  line-height: 1.45;
  color: #334155;
}

.dashboard-lane-action {
  margin-top: 8px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #475569;
}

.dashboard-lane-empty {
  margin-top: 10px;
  border: 1px dashed #d7e0ea;
  background: #f8fafc;
  padding: 14px 12px;
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.dashboard-side-card {
  padding: 12px;
}

.dashboard-side-headline {
  margin-top: 8px;
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
}

.dashboard-side-sub {
  margin-top: 4px;
  line-height: 1.5;
  color: #64748b;
}

.dashboard-handoff-row,
.dashboard-mini-row,
.dashboard-route-btn {
  width: 100%;
  text-align: left;
  cursor: pointer;
}

.dashboard-handoff-row,
.dashboard-mini-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #eef2f7;
}
.dashboard-handoff-row:last-child,
.dashboard-mini-row:last-child {
  border-bottom: 0;
}
.dashboard-handoff-row:hover,
.dashboard-mini-row:hover {
  color: #0f172a;
}

.dashboard-handoff-main,
.dashboard-mini-main {
  min-width: 0;
  flex: 1;
}

.dashboard-handoff-name,
.dashboard-mini-name {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
}

.dashboard-handoff-meta,
.dashboard-mini-meta {
  margin-top: 2px;
  color: #64748b;
}

.dashboard-handoff-action,
.dashboard-mini-action {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  white-space: nowrap;
}

.dashboard-priority-empty {
  margin-top: 8px;
  border: 1px dashed #d7e0ea;
  background: #f8fafc;
  padding: 12px;
  font-size: 11px;
  color: #64748b;
}

.dashboard-snapshot-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.dashboard-snapshot-cell {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 10px;
}

.dashboard-snapshot-label {
  display: block;
  color: #64748b;
}

.dashboard-snapshot-value {
  display: block;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.dashboard-route-btn {
  margin-top: 8px;
  border: 1px solid #d7e0ea;
  background: #f8fafc;
  padding: 9px 10px;
  font-size: 11px;
  font-weight: 700;
  color: #334155;
  transition: background-color 0.15s, border-color 0.15s;
}
.dashboard-route-btn:hover {
  border-color: #94a3b8;
  background: #ffffff;
}

@media (max-width: 1279px) {
  .dashboard-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-focus-band,
  .dashboard-lane-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 767px) {
  .dashboard-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .dashboard-header-actions {
    width: 100%;
  }
  .dashboard-focus-name {
    font-size: 18px;
  }
  .dashboard-snapshot-grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}`],
})
export class PageDashboardComponent implements OnInit, OnDestroy {
    public visitStats: any = {};
    public todayVisits: any[] = [];
    public totalPatients: number = 0;
    public totalPrescriptions: number = 0;
    public currentTime: string = '';
    public activeFilter: string = '';
    private clockInterval: any = null;
    private refreshInterval: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.updateClock();
        this.clockInterval = setInterval(() => { this.updateClock(); this.service.render(); }, 30000);
        this.refreshInterval = setInterval(() => this.load(), 30000);
        await this.load();
        await this.service.render();
    }

    ngOnDestroy() {
        if (this.clockInterval) clearInterval(this.clockInterval);
        if (this.refreshInterval) clearInterval(this.refreshInterval);
    }

    private updateClock() {
        const now = new Date();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        const w = ['일', '월', '화', '수', '목', '금', '토'];
        const h = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        this.currentTime = `${m}/${d} (${w[now.getDay()]}) ${h}:${min}`;
    }

    public async load() {
        const { code, data } = await wiz.call('load');
        if (code === 200) {
            this.visitStats = data.visit_stats || {};
            this.todayVisits = data.today_visits || [];
            this.totalPatients = data.total_patients || 0;
            this.totalPrescriptions = data.total_prescriptions || 0;
        }
        await this.service.render();
    }

    private waitMinutes(visit: any): number {
        if (!visit?.created_at) return 0;
        const created = new Date(visit.created_at);
        if (Number.isNaN(created.getTime())) return 0;
        return Math.max(0, Math.floor((Date.now() - created.getTime()) / 60000));
    }

    public reviewQueueCount() {
        return this.todayVisits.filter((v: any) => ['charting', 'prescribing'].includes(v.status)).length;
    }

    private sortByWait(list: any[]): any[] {
        return [...list].sort((a: any, b: any) => this.waitMinutes(b) - this.waitMinutes(a));
    }

    public readyVisits(limit: number = 8) {
        return this.sortByWait(this.todayVisits.filter((v: any) => v.status === 'ready')).slice(0, limit);
    }

    public inProgressVisits(limit: number = 8) {
        return this.sortByWait(this.todayVisits.filter((v: any) => v.status === 'in_progress')).slice(0, limit);
    }

    public reviewVisits(limit: number = 8) {
        return this.sortByWait(this.todayVisits.filter((v: any) => ['charting', 'prescribing'].includes(v.status))).slice(0, limit);
    }

    public waitingHandoffVisits(limit: number = 5) {
        return this.sortByWait(this.todayVisits.filter((v: any) => v.status === 'waiting')).slice(0, limit);
    }

    public readyCount() {
        return this.todayVisits.filter((v: any) => v.status === 'ready').length;
    }

    public inProgressCount() {
        return this.todayVisits.filter((v: any) => v.status === 'in_progress').length;
    }

    public reviewCount() {
        return this.reviewQueueCount();
    }

    public waitingCount() {
        return this.todayVisits.filter((v: any) => v.status === 'waiting').length;
    }

    public getClinicalLead(visit: any) {
        return visit?.visit_reason || visit?.memo || '추가 메모가 없습니다.';
    }

    public actionableVisits(limit: number = 20) {
        const order: any = { ready: 0, in_progress: 1, charting: 2, prescribing: 3 };
        return this.todayVisits
            .filter((v: any) => ['ready', 'in_progress', 'charting', 'prescribing'].includes(v.status))
            .sort((a: any, b: any) => {
                const d = (order[a.status] ?? 9) - (order[b.status] ?? 9);
                return d !== 0 ? d : this.waitMinutes(b) - this.waitMinutes(a);
            })
            .slice(0, limit);
    }

    public async filterStatus(status: string) {
        this.activeFilter = status;
        await this.service.render();
    }

    public filteredVisits(): any[] {
        if (!this.activeFilter) return this.actionableVisits(50);
        if (this.activeFilter === 'review') {
            return this.todayVisits.filter((v: any) => ['charting', 'prescribing'].includes(v.status));
        }
        return this.todayVisits.filter((v: any) => v.status === this.activeFilter);
    }

    public nextPriorityVisit() {
        return this.actionableVisits(1)[0] || null;
    }

    public getPriorityActionLabel(visit: any) {
        if (visit.status === 'ready') return '진료 시작';
        if (visit.status === 'prescribing') return '처방 정리';
        if (visit.status === 'charting') return '기록 정리';
        if (visit.status === 'waiting') return '접수 확인';
        return '차트 열기';
    }

    public async openPriorityVisit(visit?: any) {
        const target = visit || this.nextPriorityVisit();
        if (!target) return;
        if (target.status === 'ready') {
            await this.changeStatus(target);
            return;
        }
        if (target.status === 'waiting') {
            this.service.href('/reception');
            return;
        }
        this.service.href(`/chart/${target.id}`);
    }

    public getWaitTime(visit: any): string {
        if (['completed', 'cancelled'].includes(visit.status)) return '-';
        const m = this.waitMinutes(visit);
        if (m < 1) return '방금';
        if (m < 60) return `${m}분`;
        return `${Math.floor(m / 60)}h ${m % 60}m`;
    }

    public getWaitColor(visit: any): string {
        const m = this.waitMinutes(visit);
        if (m > 30) return 'text-red-600';
        if (m > 15) return 'text-amber-600';
        return 'text-slate-500';
    }

    public getAge(visit: any): string {
        const bd = visit.patient_birth_date;
        if (!bd) return '';
        const birth = new Date(bd);
        if (Number.isNaN(birth.getTime())) return '';
        return `${Math.floor((Date.now() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000))}세`;
    }

    public getInitials(visit: any): string {
        const name = visit.patient_name || '';
        return name.length > 0 ? name.charAt(0) : '?';
    }

    public isUrgentWait(visit: any): boolean {
        return ['waiting', 'ready'].includes(visit.status) && this.waitMinutes(visit) > 20;
    }

    public getStatusLabel(status: string) {
        const map: any = {
            waiting: '대기', intake: '예진', ready: '진료대기',
            in_progress: '진료중', charting: '기록정리',
            prescribing: '처방', completed: '완료', cancelled: '취소'
        };
        return map[status] || status;
    }

    public getStatusBadge(status: string) {
        const map: any = {
            waiting: 'bg-amber-50 text-amber-700',
            ready: 'bg-emerald-50 text-emerald-700',
            in_progress: 'bg-blue-50 text-blue-700',
            charting: 'bg-indigo-50 text-indigo-700',
            prescribing: 'bg-violet-50 text-violet-700',
            completed: 'bg-slate-50 text-slate-500',
        };
        return map[status] || 'bg-slate-50 text-slate-500';
    }

    public getStatusDot(status: string) {
        const map: any = {
            waiting: 'bg-amber-400', ready: 'bg-emerald-400',
            in_progress: 'bg-blue-400', charting: 'bg-indigo-400',
            prescribing: 'bg-violet-400', completed: 'bg-slate-300',
        };
        return map[status] || 'bg-slate-300';
    }

    public getVisitTypeLabel(type: string) {
        const map: any = { outpatient: '초진', initial: '초진', revisit: '재진', followup: '재진', emergency: '응급' };
        return map[type] || '외래';
    }

    public activeFilterLabel() {
        const map: any = {
            '': '현재 워크리스트',
            waiting: '접수 대기',
            ready: '진료 대기',
            in_progress: '진료 진행 중',
            review: '기록 · 처방 정리',
            completed: '완료 기록',
        };
        return map[this.activeFilter] || '현재 워크리스트';
    }

    public prioritySupportText(visit: any) {
        return this.getClinicalLead(visit);
    }

    public async changeStatus(visit: any) {
        if (visit.status !== 'ready') return;
        const { code } = await wiz.call('change_status', { visit_id: visit.id, status: 'in_progress' });
        if (code === 200) {
            this.service.href(`/chart/${visit.id}`);
        }
    }

    public goReception() {
        this.service.href('/reception');
    }
}

export default PageDashboardComponent;